import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { setFavicon, setTitle } from "./setmeta";

const FaviconUpdater = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const hostname = window.location.hostname.split(".")[0];
        console.log("hostname",hostname)
        const response = await axios.get("https://payyug.in/api/get-company", {
          params: { domain: hostname },
        });
        const data = response.data;
        console.log("favicon",data)
        if (data?.favicon) setFavicon(`https://payyug.in/${data.favicon}`);
        if (data?.name) setTitle(`${data.name}`);
      } catch (err) {
        console.error("Company fetch failed:", err);
        setTitle("faysermfi");
      } finally {
        setLoading(false);
      }
    };

    fetchCompany();
  }, [location.pathname]);

  if (loading) return <div>Loading...</div>;
  return null;
};

export default FaviconUpdater;
